<template>
  <div id="project-news">
    <news-head></news-head>
    <news-nav></news-nav>
    <pub-nav></pub-nav>
    <div class="project-box">
      <div class="time-box">
        <ul>
          <li v-for="(item,index) in timeData" :key="index" :class="{active:timeStatus==index}" @click="getStyle(index)">{{item}}</li>
        </ul>
      </div>
      <div class="project-bottom">
        <el-row :gutter="20">
          <el-col :span="6" v-for="(item,index) in newList" :key="index">
            <div class="project-col">
              <div class="img-box">
                <img src="../../assets/images/project.png" alt>
              </div>
              <div class="content-box">
                <h5>{{item.title}}</h5>
                <span>2019.08.25</span>
                <i class="iconfont">&#xe60d;</i>
                <!-- <ul>
                  <li>
                    <span>目标筹款</span>
                    <b>{{item.aims}}</b>
                  </li>
                  <li>
                    <span>当前筹款</span>
                    <i>{{item.current}}</i>
                  </li>
                </ul>-->
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <news-foot></news-foot>
  </div>
</template>
<script>
import newsHead from "../Public/head";
import newsNav from "../Public/nav";
import newsFoot from "../Public/foot";
import pubNav from "./pub_nav";
export default {
  components: {
    newsHead,
    newsNav,
    newsFoot,
    pubNav
  },
  data() {
    return {
      timeStatus:0,
      timeData:[2018,2019,2019,2019,2019,2019,2019,2019,2019,2019,],
      classShow: true,
      classHide: false,
      newList: [
        {
          id: 1,
          title: "被遗弃半个世纪麻风病白内障患者走上复明路",
          aims: "3,300,000",
          current: "1,901,758.07"
        },
        {
          id: 1,
          title: "被遗弃半个世纪麻风病白内障患者走上复明路",
          aims: "3,300,000",
          current: "1,901,758.07"
        },
        {
          id: 1,
          title: "被遗弃半个世纪麻风病白内障患者走上复明路",
          aims: "3,300,000",
          current: "1,901,758.07"
        },
        {
          id: 1,
          title: "被遗弃半个世纪麻风病白内障患者走上复明路",
          aims: "3,300,000",
          current: "1,901,758.07"
        },
        {
          id: 1,
          title: "被遗弃半个世纪麻风病白内障患者走上复明路",
          aims: "3,300,000",
          current: "1,901,758.07"
        },
        {
          id: 1,
          title: "被遗弃半个世纪麻风病白内障患者走上复明路",
          aims: "3,300,000",
          current: "1,901,758.07"
        },
        {
          id: 1,
          title: "被遗弃半个世纪麻风病白内障患者走上复明路",
          aims: "3,300,000",
          current: "1,901,758.07"
        },
        {
          id: 1,
          title: "被遗弃半个世纪麻风病白内障患者走上复明路",
          aims: "3,300,000",
          current: "1,901,758.07"
        }
      ]
    };
  },
  methods:{
    getStyle(id){
      // console.log(id,'999999');
      this.timeStatus = id;
    }
  }
};
</script>
<style lang="scss" scoped>
#app-project {
  width: 100%;
  margin: 20px 0;
  margin-top: 0;
}
.project-box {
  width: 1300px;
  margin: 0 auto;
  padding: 30px 0;
  .time-box {
    > ul {
      margin-top: 18px;
      margin-bottom: 38px;
      display: flex;
      flex-wrap: wrap;
      > li {
        padding: 0 18px;
        height: 33px;
        background-color: #ffffff;
        border-radius: 18px;
        border: solid 1px #cccccc;
        line-height: 33px;
        color: #999999;
        font-size: 16px;
        margin-right: 20px;
        cursor: pointer;
        &.active{
          border-color: #c30d23;
          color: #c30d23;
        }
      }
    }
  }
  .project-top {
    position: relative;
    margin-bottom: 60px;
    > h3 {
      font-size: 30px;
      color: #000;
      font-weight: normal;
      padding: 14px 0;
    }
    .more-box {
      position: absolute;
      right: 0;
      top: 20px;
      > p {
        font-size: 12px;
        color: #333333;
      }
      > h6 {
        font-size: 14px;
        color: #333333;
      }
    }
    .border-box {
      width: 1300px;
      height: 1px;
      border: 1px solid #c30d23;
      border-bottom: 3px solid #c30d23;
    }
  }
  .project-bottom {
    .project-col {
      cursor: pointer;
      margin-bottom: 26px;
      transition: ease-out 0.6s;
      &:hover {
        transform: scale(1.05);
        box-shadow: 0px 0px 35px 0px rgba(9, 1, 4, 0.21);
        .content-box {
          background-color: #c30d23;
          transition: all 1.5s;
          > h5 {
            color: #fff;
          }
          > span {
            color: #fff;
          }
          >i{
            color: #fff;
          }
        }
      }
      .img-box {
        width: 100%;
        height: 260px;
        > img {
          width: 100%;
          height: 100%;
        }
      }
      .content-box {
        padding: 20px 24px 20px 9px;
        position: relative;
        > h5 {
          font-size: 18px;
          color: #333;
          font-weight: 500;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        > span {
          display: block;
          color: #999999;
          font-size: 14px;
          margin-top: 16px;
        }
        >i{
          font-style: normal;
          position: absolute;
          bottom: 20px;
          right: 20px;
          font-size: 22px;
        }
        > ul {
          > li {
            list-style: none;
            margin-top: 6px;
            > span {
              font-size: 14px;
              color: #999;
            }
            > i {
              font-style: normal;
              font-size: 16px;
              color: #c30d23;
              font-weight: 700;
            }
            > b {
              font-size: 16px;
              // font-weight: normal;
              color: #333;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectNews/index.vue